export default __webpack_public_path__ + "static/daan-37b386d5fae59f0fb078865c64724bbe.png";